import type { Actions } from '@atlassian/jira-issue-table-selection-services';
import type { State } from '../../reducers/types';

export const getLastClickedRow = (state: State): string | undefined =>
	state.bulkSelection.lastClickedRow;
export const getSelectionServiceActions = (state: State): Actions | undefined =>
	state.bulkSelection.selectionServiceActions;
export const hasSelection = (state: State): boolean => state.bulkSelection.hasSelection;
